import React from 'react';
import './ContactosPage.css';

const ContactosPage = () => {
  return (
    <div className="contactos-page">
      <h1>Contactos</h1>
      <h2>Email: danielmjc73@gmail.com</h2>
      <h3>Telefone: +258 84 450 7228 / 87 940 7228</h3>
      <h4>Endereço: Matola- Moçambique</h4>
      <h5>© 2024-2025 Desenvolvido por Chaúca Creative, Lda. Todos os direitos reservados.</h5>
    </div>
  );
};

export default ContactosPage;
